import { createBaseApi } from '../baseApi';
import { BACKEND_URL } from '../../../utils/config';

const isV5 = BACKEND_URL.endsWith('/api');
const productApi = createBaseApi('productApi');

export const enhancedProductApi = productApi.injectEndpoints({
  endpoints: (builder) => ({

    getProducts: builder.query({
      query: (params) => ({
        url: '/products',
        params: isV5 ? { ...params, populate: '*' } : params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: 'Product', id })),
            { type: 'Product', id: 'LIST' },
          ]
          : [{ type: 'Product', id: 'LIST' }],
    }),    getProduct: builder.query({
      query: (id) => {
        if (!id) {
          throw new Error('Product ID is required');
        }
        return {
          url: `/products/${id}`,
          params: isV5 ? { populate: '*' } : undefined,
          credentials: 'omit',  // Don't send cookies or authorization headers
          headers: { 
            // Explicitly clear Authorization header for this endpoint
            Authorization: ''
          }
        };
      },
      transformResponse: (response) => {
        // Unwrap Strapi v5 { data, meta } envelope
        const product = response?.data || response;
        
        // Transform photos URLs if they're relative
        if (product.photos) {
          product.photos = product.photos.map(photo => ({
            ...photo,
            url: photo.url?.startsWith('http') ? photo.url : `${BACKEND_URL.replace('/api', '')}${photo.url}`,
            formats: {
              ...photo.formats,
              thumbnail: photo.formats?.thumbnail ? {
                ...photo.formats.thumbnail,
                url: photo.formats.thumbnail.url?.startsWith('http') 
                  ? photo.formats.thumbnail.url 
                  : `${BACKEND_URL.replace('/api', '')}${photo.formats.thumbnail.url}`
              } : null
            }
          }));
        }
        
        // Log transformed address info
        if (product.shippingAddress || product.pickupAddress) {
        }
        
        return product;
      },
      providesTags: (result, error, id) => [{ type: 'Product', id }]
    }),
    toggleLike: builder.mutation({
      query: ({ productId }) => ({
        url: `/products/${productId}/like`,
        method: 'POST'
      }),
      invalidatesTags: (result, error, { productId }) => [
        { type: 'Product', id: productId },
        { type: 'User', id: 'CURRENT' },
        { type: 'User', id: 'FAVORITES' }
      ]
    }),
    getLikeStatus: builder.query({
      query: (productId) => ({
        url: `/products/${productId}/like-status`
      }),
      providesTags: (result, error, productId) => [
        { type: 'Product', id: productId },
        { type: 'User', id: 'CURRENT' }
      ]
    })
  })
});

export const {
  useGetProductQuery,
  useGetProductsQuery,
  useToggleLikeMutation,
  useGetLikeStatusQuery
} = enhancedProductApi;
